module.exports = function(h, row) {
    return row.redeemed;
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory/coupon/redeemed.jsx